import { Button, ButtonProps, CircularProgress, styled } from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';

import { SignupStore } from '../../signup-store';

const StepButtonsContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
        flexDirection: 'row-reverse',
        marginTop: theme.spacing(3)
    }
}));

const BackButton = styled(Button)(({ theme }) => ({
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
        marginTop: 0
    }
}));

const NextButton = styled(Button)(({ theme }) => ({
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
        width: 300
    }
}));

type StepButtonsProps = {
    onNextBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
    nextBtnLabel: string;
    hasBackBtn?: boolean;
    backBtnEventName?: string;
    loading?: boolean;
} & ButtonProps;

export const StepButtons = observer((props: StepButtonsProps) => {
    const { goToPreviousStep, sendEvent } = injectTSDI(SignupStore);
    const { translate } = injectTSDI(I18nStore);

    const {
        onNextBtnClick,
        nextBtnLabel,
        hasBackBtn = false,
        loading = false,
        disabled = false,
        backBtnEventName,
        ...rest
    } = props;

    const onBackBtnClick = () => {
        if (backBtnEventName) {
            sendEvent(backBtnEventName);
        }
        goToPreviousStep();
    };

    return (
        <StepButtonsContainer>
            <NextButton
                variant="contained"
                color="primary"
                onClick={onNextBtnClick}
                disabled={disabled || loading}
                {...rest}
            >
                {loading ? (
                    <CircularProgress size={25} color="inherit" />
                ) : (
                    translate(nextBtnLabel)
                )}
            </NextButton>
            {hasBackBtn && (
                <BackButton color="primary" onClick={onBackBtnClick}>
                    {translate('commons.backward')}
                </BackButton>
            )}
        </StepButtonsContainer>
    );
});
